<template>
  <div style="margin-top: -1em">
    <span class="col-12 animated-dropDown">
      <Dropdown v-model="selectedPolizzaLatitudine" :options="policies" style="min-width:15em"
                :placeholder="$t('topBarLatitudini.selectContract')"
                :filter="true" filterMatchMode="startsWith" option-label="numeroContratto" @change="setContract()"
                :disabled="loading">
  <template #value="slotProps">
    <div class="grid" v-if="slotProps.value">
      <div class="col-12" style="margin-top: .3em;"><b class="blue-b">{{ slotProps.value.numeroContratto }}</b></div>
      <div class="col-12"><p class="green-i">{{ slotProps.value.nomeAssicurato }}</p></div>
    </div>
    <div v-else>
      <div class="col-12" style="height:.8em"></div>
    <i class="blue-i" style="line-height: 1.8em;">{{ slotProps.placeholder }}</i>
    </div>
  </template>
  <template #option="slotProps">
      <div class="grid col-12" style="margin-top: .3em;">
        <b class="blue-b">{{ slotProps.option.numeroContratto}}</b>
        <b class="blue-b">-</b>
        <b class="green-b" style="margin-left:1em">{{ slotProps.option.nomeAssicurato }}</b>
      </div>
      <div class="col-12"><p class="green-i"></p></div>
  </template>
</Dropdown>
    </span>
  </div>
</template>

<script>
import {useLoadingStore} from "@/store/loadingStore";
import {VueScreenSizeMixin} from 'vue-screen-size';
import {useLatitudeStore} from "@/store/latitudeStore";
import LatitudiniService from "@/service/LatitudiniService";
import {useUserStore} from "@/store/userStore";

export default {
  mixins: [VueScreenSizeMixin],
  beforeCreate() {
    this.latitudiniService = new LatitudiniService()
    this.loadingStore = useLoadingStore()
    this.userStore = useUserStore()
    this.latitudeStore = useLatitudeStore()
  },
  mounted() {
    if(!this.$methods.isEmpty(this.latitudeStore.selectedPolizzaLatitudine) &&
        this.$methods.isEmpty(this.selectedPolizzaLatitudine)){
      this.selectedPolizzaLatitudine = this.$methods.deepClone(this.latitudeStore.selectedPolizzaLatitudine)
    }
    this.getPolizzeAnagrafica()
  },
  data() {
    return {
      selectedPolizzaLatitudine: null,
      policies: [],
    }
  },
  computed: {
    loading() {
      return this.loadingStore.loading
    },
    user() {
      return this.userStore.user
    },
    profile() {
      return this.$methods.isEmpty(this.user) ? null : this.user.profile
    }
  },
  watch:{
    profile() {
      this.getPolizzeAnagrafica();
    }
  },
  methods: {
    getPolizzeAnagrafica() {
      if (!this.$methods.isEmpty(this.user) && !this.$methods.isEmpty(this.profile)) {
        this.loadingStore.startLoading()
        this.latitudiniService.getPolizzeAnagrafica(this.user.username, this.profile.role.code).then(response => {
          this.policies = JSON.parse(response)
          if (this.policies.length === 1) {
            this.selectedPolizzaLatitudine = this.policies[0]
            this.latitudeStore.setContract(this.selectedPolizzaLatitudine)
          }
          this.loadingStore.stopLoading()
        }).catch(() => {
          this.loadingStore.stopLoading()
          this.$toast.add({
            severity: "error",
            summary: this.$t("toasts.somethingWentWrong.summary"),
            detail: this.$t("toasts.somethingWentWrong.detail"),
          });
        })
      }
    },
    setContract() {
      this.latitudeStore.setContract(this.selectedPolizzaLatitudine)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "public/assets/sass/overrides/layout_variables";

.blue-i {
  color: $blue1;
  margin-left: 1.3em;
  margin-top: .3em
}

.green-i {
  color: $green1;
  margin-left: 1em;
  margin-top: -.5em;
}

.blue-b {
  font-size: 1em;
  margin-left: 1em;
  color: $blue1;
}

 .green-b {
   font-size: 1em;
   color: $green1;
 }

.p-dropdown {
  border: none;
  height: 4.5em;
  border-right: 1px solid $blue1;
  border-left: 1px solid $blue1;
}
</style>
